import Enumerator from '../global/Enumerator';

export const contactEmploymentTypes = [
  'none',
  'salaried_employee',
  'self_employed',
  'retired',
  'unemployed'
];

export class ContactEmploymentType extends Enumerator {
  static default() {
    return this.of('none');
  }
}

ContactEmploymentType.initEnum({
  none: {
    get title() {
      return 'None selected';
    }
  },
  salaried_employee: {
    get title() {
      return 'Salaried employee';
    }
  },
  self_employed: {
    get title() {
      return 'Self-Employed';
    }
  },
  retired: {
    get title() {
      return 'Retired';
    }
  },
  unemployed: {
    get title() {
      return 'Unemployed';
    }
  }
});

export default {
  contactEmploymentTypes,
  ContactEmploymentType
};
